// extracted by mini-css-extract-plugin
export var avatarContainer = "_4t-0";
export var avatarTypingWave = "_4t-i";
export var gray = "_4t-f";
export var green = "_4t-c";
export var icon = "_4t-9";
export var image = "_4t-1";
export var lg = "_4t-6";
export var md = "_4t-5";
export var presenceDot = "_4t-b";
export var red = "_4t-d";
export var sm = "_4t-4";
export var status = "_4t-a";
export var typingDot = "_4t-h";
export var typingPill = "_4t-g";
export var xl = "_4t-7";
export var xs = "_4t-3";
export var xxl = "_4t-8";
export var xxs = "_4t-2";
export var yellow = "_4t-e";